<template lang="html">
  <v-dialog
    v-model="dialogReadmore"
    persistent
    scrollable
    max-width="500px"
    style="border-radius: 20px;"
  >
    <v-card style="border-radius: 20px;">
      <!-- <v-card-title>{{$t('ChatSide.Read.readmore')}}</v-card-title> -->
      <v-toolbar card style="background: #1a222c !important;">
        <h2 style="color: white;">{{$t('ChatSide.Read.readmore')}}</h2>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text style="height: 300px; overflow-y: scroll;">
        <p v-html="convert(detailReadmore.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="closeDialog()">{{$t('AnswerQuestion.ok')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogReadmore: Boolean,
    detailReadmore: {}
  },
  methods: {
    closeDialog () {
      this.$emit('closeReadmoreDialog', false)
    },
    convert(msg) {
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g
      // var word = msg.match(regex)
      // console.log(word)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          // var word = msg.match(regex)
          // @click.native.capture=method
          processedContent = processedContent.replace('&lt;tax&gt;', `<b style="color:#1976d2; cursor:pointer;" >@`)
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
        }
      }
      return processedContent
    }
  }
}
</script>

<style lang="css" scoped>
/* >>>.v-card .theme--light {
  border-radius: 20px !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_chat/ReadmoreDialog.vue